/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { footerActualDetailConfig } from '../../config/footer.config';
export interface IFooterActualDetailDetailPluginMethods
  extends IPluginMethodMap {
  getFooterActualDetailDetailSync(args?: any): any;
}

export class FooterActualDetailDetailPlugin implements IAgentPlugin {
  readonly methods: IFooterActualDetailDetailPluginMethods;

  constructor() {
    this.methods = {
      getFooterActualDetailDetailSync:
        this.getFooterActualDetailDetailSync.bind(this),
    };
  }

  getFooterActualDetailDetailSync(args?: any) {
    return {
      footer: footerActualDetailConfig,
    };
  }
}
